module.exports = __webpack_public_path__ + "static/media/boat-img-36.78eb67c9.jpg";